import { FileUploader } from 'ng2-file-upload';

export type WorkTemplateQuestionImageAttributes = {
  thumbnail?: string;
  _destroy?: boolean;
  uuid?: string;
  file_name?: string;
  file_extension?: string;
};

export class WorkTemplateQuestion {
  id: number | null = null;
  content: string = '';
  order: number | null = null;
  image_attributes: WorkTemplateQuestionImageAttributes | null = null;
  image?: WorkTemplateQuestionImageAttributes | null;
  image_local?: (File & { item_index?: number }) | null;
  fileUploader?: FileUploader;
  created_at?: string;
  is_single_choice?: boolean;
  _destroy?: boolean;
  image_error?: string;
}
